export const reportConfigs = [
  {
    ID: 101,
    reportType: "filterCleaning",
    title: "Filter Cleaning Record",
    filename: "Filter_Cleaning_Record",
    showEquipmentId: true,
    equipmentIdLabel: "Equipment ID. No./AHU. ID. No:",
    columns: [
      { title: "S.No", key: "sNo" },
      { title: "Filter Unique ID", key: "filterId" },
      { title: "Filter Micron", key: "micron" },
      { title: "Compressed Air Pressure (KG/cm2)", key: "airPressure" },
      { title: "RO Water Pressure (Kg/Cm2)", key: "waterPressure" },
      { title: "Cleaned On (Date)", key: "cleanedDate" },
      { title: "Cleaned On (Time)", key: "cleanedTime" },
      { title: "Performed By", key: "performedBy" },
    ],
    data: [],
  },
  {
    ID: 102,
    reportType: "filterHistory",
    title: "Filter History Report",
    filename: "Filter_History_Report",
    showEquipmentId: true,
    equipmentIdLabel: "Equipment ID. No./AHU. ID. No:",
    columns: [
      { title: "S.No", key: "sNo" },
      { title: "Date", key: "date" },
      { title: "Time", key: "time" },
      { title: "Action", key: "action" },
      { title: "Performed By", key: "performedBy" },
      { title: "Platform", key: "platform" },
      { title: "Data", key: "data" },
    ],
    data: [
      // First set (sNo 1 to 15)
      // {
      //   sNo: 1,
      //   filterId: "FLT-001",
      //   date: "01/01/2025",
      //   time: "09:00:00",
      //   action: "Onboarded",
      //   performedBy: "1234",
      //   platform: "Web",
      //   data: "",
      // },
      // {
      //   sNo: 2,
      //   filterId: "FLT-001",
      //   date: "05/01/2025",
      //   time: "10:30:00",
      //   action: "Installed",
      //   performedBy: "5678",
      //   platform: "Reader",
      //   data: "",
      // },
      // {
      //   sNo: 3,
      //   filterId: "FLT-002",
      //   date: "10/01/2025",
      //   time: "14:15:00",
      //   action: "Washed-In",
      //   performedBy: "1254",
      //   platform: "Reader",
      //   data: "Pressure: 2.5 Pa",
      // },
      // {
      //   sNo: 4,
      //   filterId: "FLT-002",
      //   date: "12/01/2025",
      //   time: "15:45:00",
      //   action: "Washed-Out",
      //   performedBy: "2565",
      //   platform: "Reader",
      //   data: "Pressure: 2.0 Pa",
      // },
      // {
      //   sNo: 5,
      //   filterId: "FLT-003",
      //   date: "15/01/2025",
      //   time: "08:20:00",
      //   action: "Retired",
      //   performedBy: "2545",
      //   platform: "Web",
      //   data: "",
      // },
      // {
      //   sNo: 6,
      //   filterId: "FLT-004",
      //   date: "20/01/2025",
      //   time: "11:00:00",
      //   action: "Onboarded",
      //   performedBy: "1234",
      //   platform: "Web",
      //   data: "",
      // },
      // {
      //   sNo: 7,
      //   filterId: "FLT-004",
      //   date: "25/01/2025",
      //   time: "12:30:00",
      //   action: "Installed",
      //   performedBy: "5678",
      //   platform: "Reader",
      //   data: "",
      // },
      // {
      //   sNo: 8,
      //   filterId: "FLT-005",
      //   date: "30/01/2025",
      //   time: "09:45:00",
      //   action: "Washed-In",
      //   performedBy: "1254",
      //   platform: "Reader",
      //   data: "Pressure: 2.3 Pa",
      // },
      // {
      //   sNo: 9,
      //   filterId: "FLT-005",
      //   date: "02/02/2025",
      //   time: "16:00:00",
      //   action: "Washed-Out",
      //   performedBy: "2565",
      //   platform: "Reader",
      //   data: "Pressure: 1.8 Pa",
      // },
      // {
      //   sNo: 10,
      //   filterId: "FLT-006",
      //   date: "05/02/2025",
      //   time: "10:10:00",
      //   action: "Retired",
      //   performedBy: "2545",
      //   platform: "Web",
      //   data: "",
      // },
      // {
      //   sNo: 11,
      //   filterId: "FLT-007",
      //   date: "10/02/2025",
      //   time: "13:20:00",
      //   action: "Onboarded",
      //   performedBy: "1234",
      //   platform: "Web",
      //   data: "",
      // },
      // {
      //   sNo: 12,
      //   filterId: "FLT-007",
      //   date: "15/02/2025",
      //   time: "14:50:00",
      //   action: "Installed",
      //   performedBy: "5678",
      //   platform: "Reader",
      //   data: "",
      // },
      // {
      //   sNo: 13,
      //   filterId: "FLT-008",
      //   date: "20/02/2025",
      //   time: "09:30:00",
      //   action: "Washed-In",
      //   performedBy: "1254",
      //   platform: "Reader",
      //   data: "Pressure: 2.7 Pa",
      // },
      // {
      //   sNo: 14,
      //   filterId: "FLT-008",
      //   date: "25/02/2025",
      //   time: "15:15:00",
      //   action: "Washed-Out",
      //   performedBy: "2565",
      //   platform: "Reader",
      //   data: "Pressure: 2.1 Pa",
      // },
      // {
      //   sNo: 15,
      //   filterId: "FLT-009",
      //   date: "01/03/2025",
      //   time: "08:40:00",
      //   action: "Retired",
      //   performedBy: "2545",
      //   platform: "Web",
      //   data: "",
      // },
      // // Second set (sNo 16 to 30)
      // {
      //   sNo: 16,
      //   filterId: "FLT-001",
      //   date: "01/01/2025",
      //   time: "09:00:00",
      //   action: "Onboarded",
      //   performedBy: "1234",
      //   platform: "Web",
      //   data: "",
      // },
      // {
      //   sNo: 17,
      //   filterId: "FLT-001",
      //   date: "05/01/2025",
      //   time: "10:30:00",
      //   action: "Installed",
      //   performedBy: "5678",
      //   platform: "Reader",
      //   data: "",
      // },
      // {
      //   sNo: 18,
      //   filterId: "FLT-002",
      //   date: "10/01/2025",
      //   time: "14:15:00",
      //   action: "Washed-In",
      //   performedBy: "1254",
      //   platform: "Reader",
      //   data: "Pressure: 2.5 Pa",
      // },
      // {
      //   sNo: 19,
      //   filterId: "FLT-002",
      //   date: "12/01/2025",
      //   time: "15:45:00",
      //   action: "Washed-Out",
      //   performedBy: "2565",
      //   platform: "Reader",
      //   data: "Pressure: 2.0 Pa",
      // },
      // {
      //   sNo: 20,
      //   filterId: "FLT-003",
      //   date: "15/01/2025",
      //   time: "08:20:00",
      //   action: "Retired",
      //   performedBy: "2547",
      //   platform: "Web",
      //   data: "",
      // },
      // {
      //   sNo: 21,
      //   filterId: "FLT-004",
      //   date: "20/01/2025",
      //   time: "11:00:00",
      //   action: "Onboarded",
      //   performedBy: "1234",
      //   platform: "Web",
      //   data: "",
      // },
      // {
      //   sNo: 22,
      //   filterId: "FLT-004",
      //   date: "25/01/2025",
      //   time: "12:30:00",
      //   action: "Installed",
      //   performedBy: "5678",
      //   platform: "Reader",
      //   data: "",
      // },
      // {
      //   sNo: 23,
      //   filterId: "FLT-005",
      //   date: "30/01/2025",
      //   time: "09:45:00",
      //   action: "Washed-In",
      //   performedBy: "1254",
      //   platform: "Reader",
      //   data: "Pressure: 2.3 Pa",
      // },
      // {
      //   sNo: 24,
      //   filterId: "FLT-005",
      //   date: "02/02/2025",
      //   time: "16:00:00",
      //   action: "Washed-Out",
      //   performedBy: "2565",
      //   platform: "Reader",
      //   data: "Pressure: 1.8 Pa",
      // },
      // {
      //   sNo: 25,
      //   filterId: "FLT-006",
      //   date: "05/02/2025",
      //   time: "10:10:00",
      //   action: "Retired",
      //   performedBy: "2545",
      //   platform: "Web",
      //   data: "",
      // },
      // {
      //   sNo: 26,
      //   filterId: "FLT-007",
      //   date: "10/02/2025",
      //   time: "13:20:00",
      //   action: "Onboarded",
      //   performedBy: "1234",
      //   platform: "Web",
      //   data: "",
      // },
      // {
      //   sNo: 27,
      //   filterId: "FLT-007",
      //   date: "15/02/2025",
      //   time: "14:50:00",
      //   action: "Installed",
      //   performedBy: "5678",
      //   platform: "Reader",
      //   data: "",
      // },
      // {
      //   sNo: 28,
      //   filterId: "FLT-008",
      //   date: "20/02/2025",
      //   time: "09:30:00",
      //   action: "Washed-In",
      //   performedBy: "1254",
      //   platform: "Reader",
      //   data: "Pressure: 2.7 Pa",
      // },
      // {
      //   sNo: 29,
      //   filterId: "FLT-008",
      //   date: "25/02/2025",
      //   time: "15:15:00",
      //   action: "Washed-Out",
      //   performedBy: "2565",
      //   platform: "Reader",
      //   data: "Pressure: 2.1 Pa",
      // },
      // {
      //   sNo: 30,
      //   filterId: "FLT-009",
      //   date: "01/03/2025",
      //   time: "08:40:00",
      //   action: "Retired",
      //   performedBy: "2545",
      //   platform: "Web",
      //   data: "",
      // },
    ],
  },
  {
    ID: 103,
    reportType: "auditTrail",
    title: "Audit Trail Record",
    filename: "Audit_Trail_Record",
    showEquipmentId: false,
    columns: [
      { title: "S.No", key: "sNo" },
      { title: "Date", key: "date" },
      { title: "Time", key: "time" },
      { title: "User ID", key: "userId" },
      { title: "Description", key: "description" },
    ],
    data: [
      // {
      //   sNo: 1,
      //   date: "02/07/2025",
      //   time: "08:00:00",
      //   userId: "1234",
      //   description: "Login",
      // },
      // {
      //   sNo: 2,
      //   date: "02/07/2025",
      //   time: "08:05:00",
      //   userId: "1234",
      //   description: "Reset Password",
      // },
      // {
      //   sNo: 3,
      //   date: "03/07/2025",
      //   time: "10:45:00",
      //   userId: "5468",
      //   description: "User Created",
      // },
    ],
  },
  // {
  //   reportType: "auditTrail",
  //   title: "Audit Trail Record",
  //   filename: "Audit_Trail_Record",
  //   showEquipmentId: false,
  //   columns: [
  //     { title: "S.No", key: "sNo" },
  //     { title: "Date", key: "date" },
  //     { title: "Time", key: "time" },
  //     { title: "User ID", key: "userId" },
  //     { title: "Description", key: "description" }
  //   ],
  //   data: []
  // },
  {
    ID: 104,
    reportType: "filterDrying",
    title: "Filter Drying Record",
    filename: "Filter_Drying_Record",
    showEquipmentId: true,
    equipmentIdLabel: "Equipment ID. No./AHU. ID. No:",
    columns: [
      { title: "S.No", key: "sNo" },
      { title: "Filter Unique ID", key: "filterId" },
      { title: "Filter Micron", key: "micron" },
      { title: "Dryer Temperature (°C)", key: "dryerTemp" },
      { title: "Drying Start Date", key: "startDate" },
      { title: "Drying Start Time", key: "startTime" },
      { title: "Drying End Date", key: "endDate" },
      { title: "Drying End Time", key: "endTime" },
      { title: "Performed By", key: "performedBy" },
    ],
    data: [
      // {
      //   sNo: 1,
      //   filterId: "FLT-001",
      //   micron: "5",
      //   dryerTemp: "45",
      //   startDate: "12-07-2025",
      //   startTime: "10:00",
      //   endDate: "12-07-2025",
      //   endTime: "11:00",
      //   performedBy: "4523",
      // },
    ],
  },
  {
    ID: 105,
    reportType: "barcodePrinting",
    title: "BarCode Printing Record",
    filename: "BarCode_Printing_Record",
    showEquipmentId: false,
    columns: [
      { title: "S.No", key: "sNo" },
      { title: "Date", key: "date" },
      { title: "Time", key: "time" },
      { title: "User ID", key: "userId" },
      { title: "Filter Unique ID", key: "filterId" },
      { title: "Filter Type", key: "filterType" },
      { title: "Print Reason", key: "reason" },
    ],
    data: [
      // {
      //   sNo: 1,
      //   date: "12/07/2025",
      //   time: "10:45:12",
      //   userId: "1234",
      //   filterId: "FTR-2025-0178",
      //   filterType: "HEPA",
      //   reason: "Initial",
      // },
      // {
      //   sNo: 2,
      //   date: "13/07/2025",
      //   time: "14:22:40",
      //   userId: "5468",
      //   filterId: "FTR-2024-1002",
      //   filterType: "Bag",
      //   reason: "Filter Damaged",
      // },
    ],
  },
  {
    ID: 106,
    reportType: "alarmsReport",
    title: "Alarms Report",
    filename: "Alarms_Report",
    showEquipmentId: false,
    columns: [
      { title: "S.No", key: "sNo" },
      { title: "Date", key: "date" },
      { title: "Time", key: "time" },
      { title: "User ID", key: "userId" },
      { title: "Filter ID", key: "filterId" },
      { title: "AHU", key: "ahu" },
      { title: "Block", key: "block" },
      { title: "Description of Deviation", key: "description" },
    ],
    data: [
      // {
      //   sNo: 1,
      //   date: "14/07/2025",
      //   time: "11:10:23",
      //   userId: "1234",
      //   filterId: "FLT-0023",
      //   ahu: "AHU-1",
      //   block: "Block-A",
      //   description: "High pressure detected",
      // },
      // {
      //   sNo: 2,
      //   date: "15/07/2025",
      //   time: "13:45:50",
      //   userId: "5468",
      //   filterId: "FLT-0071",
      //   ahu: "AHU-3",
      //   block: "Block-C",
      //   description: "Micron value deviation",
      // },
    ],
  },
{
  ID: 107,
  reportType: "ahuLifeCycleReport",
  title: "AHU Life Cycle Report",
  filename: "AHU_Life_Cycle_Report",
  showEquipmentId: true,
  columns: [
    { title: "S.No", key: "sNo" },
    { title: "AHU ID", key: "ahuId" },
    { title: "AHU Name", key: "ahuName" },
    { title: "Block", key: "block" },
    { title: "Created On", key: "installedOn" },
    { title: "Status", key: "status" },
  ],
  data: [
    // Example:
    // {
    //   sNo: 1,
    //   ahuId: "AHU-001",
    //   ahuName: "Main AHU",
    //   block: "Block A",
    //   installedOn: "01/01/2023",
    //   replacedOn: "01/06/2024",
    //   retiredOn: "",
    //   status: "Replaced",
    // },
  ],
},

{
  ID: 108,
  reportType: "filterLifeCycleReport",
  title: "Filter Life Cycle Report",
  filename: "Filter_Life_Cycle_Report",
  showEquipmentId: true,
  columns: [
    { title: "S.No", key: "sNo" },
    { title: "Filter ID", key: "filterId" },
    { title: "Filter Type", key: "filterType" },
    { title: "AHU", key: "ahu" },
    { title: "Block", key: "block" },
    { title: "Installed On", key: "installedOn" },
    { title: "Replaced On", key: "replacedOn" },
    { title: "Retired On", key: "retiredOn" },
    { title: "Status", key: "status" },
  ],
  data: [
    // Example:
    // {
    //   sNo: 1,
    //   filterId: "FLT-0012",
    //   filterType: "HEPA",
    //   ahu: "AHU-2",
    //   block: "Block B",
    //   installedOn: "01/03/2024",
    //   replacedOn: "01/07/2025",
    //   retiredOn: "",
    //   status: "Replaced",
    // },
  ],
},

  // ✅ Add more reports similarly if needed
];
